module.exports = __webpack_public_path__ + "static/media/copy.37e067c9.svg";